import { convertToTitleCase } from '../../actions/dataFormatter';

export const removeDecimalPoints = (arr) => {
  return arr.map((item) => {
    if (typeof item === "number") {
      return Number(item.toFixed(item < 100 && item > 0 ? 0 : 2));
    }
    return item;
  });
};

export const getSeries = (data) => {
  return Object.keys(data).reduce((acc, item) => {
    if (typeof data[item][0] === "number") {
      return [
        ...acc,
        {
          name: convertToTitleCase(item),
          data: removeDecimalPoints(data[item]),
        },
      ];
    }

    return acc;
  }, []);
};
